import { createHttpLink, ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { RetryLink } from '@apollo/client/link/retry'
import site from '@src/state/site/site'
import siteConfig from '@src/state/site/siteConfig'
import { PRPLAYGROUND_OR_LOCAL } from '@src/utils/localOrPlayground'
import { getJwt } from '../localStorage'

const APOLLOGRAPH_CLIENT_NAME = 'apollographql-client-name'

const httpLinkForOneGraph = createHttpLink({
  uri: siteConfig(site, PRPLAYGROUND_OR_LOCAL).oneGraphUrl,
  fetch,
  headers: {
    [APOLLOGRAPH_CLIENT_NAME]: site,
  },
})

const authLink = setContext((_, { headers }) => {
  const token = getJwt()
  return {
    fetch,
    headers: {
      ...headers,
      'chegg-wfe-token': token ? `Bearer ${token}` : '',
    },
  }
})

const MAX_RETRIES = 3
const retryLinkForOneGraph = new RetryLink({
  delay: (count: number) => {
    const initialDelay = 300
    const exponentialBackoff = 2 ** (count - 1)

    return initialDelay * exponentialBackoff
  },
  attempts: (count: number) => {
    return count <= MAX_RETRIES
  },
})

export const oneGraphClient = new ApolloClient({
  link: ApolloLink.from([authLink, retryLinkForOneGraph, httpLinkForOneGraph]),
  cache: new InMemoryCache(),
  connectToDevTools: PRPLAYGROUND_OR_LOCAL,
  defaultOptions: {
    query: {
      fetchPolicy: 'network-only',
    },
  },
})



// WEBPACK FOOTER //
// ./src/utils/http-clients/oneGraph.ts